import React, { useState } from 'react';

import DatePicker from '@common/components/datePicker';
import Config from '@app/dev/config/main';
import { useTranslation } from '@common/hooks/translation';
import { ListViewModes } from '../constants';

const HistoryHeader = ({
  changeDateFilter, start, end, activeTab, selectActiveTab,
}) => {
  const [viewMode, setViewMode] = useState(ListViewModes.CARD);
  const t = useTranslation();
  return (
    <div className="ticket-header-content">
      <div className="header-left-content">
        <div className="history-tab">
          {Config.historyTabConfig
            .map(({ title, icon }) => (
              <div
                key={title}
                className={`${activeTab === title ? 'active' : ''}`}
                onClick={() => selectActiveTab(title)}
              >
                <i className={`global-icon icon-${icon} history-tab-icons`} />
                {t(title)}
              </div>
            ))}
        </div>
      </div>
      <div className="header-right-content">
        <div className="view-mode">
          <i
            className={`global-icon icon-successRegistration ${viewMode === ListViewModes.CARD ? 'active-view-mode' : ''}`}
            onClick={() => setViewMode(ListViewModes.CARD)}
          />

          <i
            className={`global-icon icon-list-view ${viewMode === ListViewModes.LIST ? 'active-view-mode' : ''}`}
            onClick={() => setViewMode(ListViewModes.LIST)}
          />
        </div>
        <div className="r-date-picker">
          <DatePicker
            startDate={start}
            endDate={end}
            selectsRange
            onChange={changeDateFilter}
            dateFormat="d/MM/yy"
            onlyPast
          />
        </div>
      </div>
    </div>
  );
};

export default HistoryHeader;
